import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN } from '@/util/roles';

export const routes = [
	{
		path: 'audit',
		// Ops tooling, admin only, matching the Service Bus section.
		meta: {
			requireAuth: true,
			breadcrumb: 'Audit',
			minRole: ROLE_ADMIN,
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.AUDIT.OVERVIEW,
				component: () => {
					return import('@/views/depot/audit/Overview.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Audit',
					// Empty so the trail does not repeat the parent's label.
					breadcrumb: '',
				},
			},
		],
	},
];
